import { render, staticRenderFns } from "./MessageSnackbar.vue?vue&type=template&id=e01ffb6a&scoped=true"
import script from "./MessageSnackbar.vue?vue&type=script&lang=js"
export * from "./MessageSnackbar.vue?vue&type=script&lang=js"
import style0 from "./MessageSnackbar.vue?vue&type=style&index=0&id=e01ffb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ffb6a",
  null
  
)

export default component.exports